import * as React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { EmailTemplatesTab } from "./EmailTemplatesTab/EmailTemplatesTab";
import { EventSubscriptionsTab } from "./EventSubscriptionsTab/EventSubscriptionsTab";

enum TabId {
  EVENT_SUBSCRIPTIONS = "EVENT_SUBSCRIPTIONS",
  EMAIL_TEMPLATES = "EMAIL_TEMPLATES"
}

const NotificationsTab: React.FC = () => {
  const [selectedTab, setSelectedTab] = React.useState<TabId>(TabId.EVENT_SUBSCRIPTIONS);

  const handleTabChange = React.useCallback((_event: React.SyntheticEvent, newValue: TabId) => {
    setSelectedTab(newValue);
  }, []);

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleTabChange} aria-label="Notifications Tabs">
        <Tab value={TabId.EVENT_SUBSCRIPTIONS} label="Event Subscriptions" />
        <Tab value={TabId.EMAIL_TEMPLATES} label="Email Templates" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {selectedTab === TabId.EVENT_SUBSCRIPTIONS && <EventSubscriptionsTab />}
        {selectedTab === TabId.EMAIL_TEMPLATES && <EmailTemplatesTab />}
      </Box>
    </Box>
  );
};

export { NotificationsTab };
